/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

export const mapNeighborhoods = (hoods, neighborhoodIds) => {
  const hoodNames = []
  for (let i = 0; i < neighborhoodIds.length; i++) {
    const hood = hoods.find((hood) => hood.neighborhoodId === neighborhoodIds[i])
    if (hood) {
      hoodNames.push(hood.name)
    }
  }
  return hoodNames
}
